import React, {useEffect, useState} from "react";
import './ResetPasswordPage.scss';
import {useSearchParams} from "react-router-dom";
import BaseInput from "../../Components/BaseInput/BaseInput";
import BaseButton from "../../Components/BaseButton/BaseButton";
import Success from "../../Components/Success/Success";
import check from '../../Assets/Icons/check.svg'
import axios from "axios";
import {useLoader} from "../../hooks/useLoader";
import Loader from "../../Components/Loader/Loader";

const ResetPasswordPage: React.FC = () => {
    const [searchParams, ] = useSearchParams();
    const email = searchParams.get("t")
    const id = searchParams.get("s")
    const [showSuccess, setShowSuccess] = useState<boolean>(false)
    const [mdp1, setMdp1] = useState<string>('')
    const [mdp2, setMdp2] = useState<string>('')
    const [mdp2Error, setMdp2Error] = useState<string>('')

    const loader = useLoader()

    useEffect(() => {
        if (mdp1 !== mdp2) {
            setMdp2Error('Les mots de passe ne correspondent pas')
        } else {
            setMdp2Error('')
        }
    }, [mdp1, mdp2])

    const sendResetPasswordEmail = () => {
        if (mdp1.length >= 6 && mdp2.length > 0 && mdp2Error.length === 0) {
            loader.show()
            axios.put(`${process.env.REACT_APP_BART_URL}/users/${id}/updateMdp`, {id: id, newMdp: mdp1})
                .then(function () {
                    loader.hide()
                    setShowSuccess(true)
                })
                .catch(function () {
                    loader.hide()
                });
        } else {
            if (mdp1.length === 0) {
            } else if (mdp1 !== mdp2 || mdp1.length < 6) {
            }
        }
    }

    return (
        <>
            <div className="resetPassword">
                <p className="resetPassword--title">Saisie du nouveau mot de passe</p>
                <p className="resetPassword--text">Pour l’adresse email {email}</p>
                <BaseInput
                    title={"Nouveau mot de passe"}
                    helpTxt={"Votre mot de passe doit contenir 8 caractères minimum"}
                    onChange={setMdp1}
                    value={mdp1}
                    type={"password"}
                    className="resetPassword--input"
                />
                <BaseInput
                    title={"Répéter mot de passe"}
                    onChange={setMdp2}
                    errorTxt={mdp2Error}
                    value={mdp2}
                    type={"password"}
                    className="resetPassword--input"
                />
                <BaseButton text="Sauvegarder le nouveau mot de passe"
                            onClick={() => sendResetPasswordEmail()} type={'filled'} className="resetPassword--btn"/>
            </div>
            <Success
                show={showSuccess}
                title="Votre mot de passe a été mis à jour"
                subTitle="Vous pouvez fermer cette fenêtre et reprendre votre navigation"
                icone={check}
            />
            <Loader visible={loader.visible} />
        </>
    )
}

export default ResetPasswordPage
